import React, {useEffect, useState} from 'react';
import {Button, Form, Header, Icon, Modal, TextArea} from 'semantic-ui-react';
import './styles.css';
import {isUndefined} from "lodash";
import {useSelector} from "react-redux";
import {getLanguage} from "../LanguageModal/reducer";
import {getTypeExhibition} from "../../views/Home/reducer";

export default function ModalPrompt(props) {
    const {open, headerIcon, headerText, messageText, handleYes, handleNo, handleClose, handleOpen, inputText, inputDefault} =
        props;
    const typeExhibition = useSelector((state) => getTypeExhibition(state.exhibition));
    const errorMsg = 'Поле обязательно для заполнения';
    const stateInit = {
        text: inputDefault ?? '',
        error: !isUndefined(inputText) && (isUndefined(inputDefault) || inputDefault.length === 0) ? errorMsg : ''
    }
    const [stateInput, setStateInput] = useState(stateInit);
    const language = useSelector(getLanguage);
    const languageString = language[0]+language[1];

    useEffect(() => {
        setStateInput(stateInit);
    }, [props]);

    function setField(value) {
        setStateInput({
            text: value,
            error: (value.length ? '' : errorMsg)
        });
    }

    return (
        <Modal
            closeIcon
            dimmer
            centered
            open={open}
            onClose={handleClose}
            onOpen={handleOpen}
            closeOnDimmerClick={true}
            className="modal-prompt"
        >
            <Header icon={headerIcon} content={headerText} />
            <Modal.Content>
                <p>{messageText ?? ''}</p>
                { !isUndefined(inputText) && inputText.length ?
                    <Form>
                        <TextArea
                            className="modal-prompt-field modal-prompt-reason"
                            placeholder={inputText}
                            value={stateInput.text}
                            onChange={(e) => setField(e.target.value)}
                        />
                        <span className="modal-prompt-field-error">{stateInput.error}</span>
                    </Form> : '' }
            </Modal.Content>
            <Modal.Actions>
                <Button className='modal-no-btn' onClick={handleNo}>
                    <Icon name='remove' /> {languageString === "en" ? 'No' : 'Нет'}
                </Button>
                <Button className={`modal-yes-btn ${typeExhibition}`} onClick={() => handleYes(stateInput.text)} disabled={stateInput.error !== ''}>
                    <Icon name='checkmark' /> {languageString === "en" ? 'Yes' : 'Да'}
                </Button>
            </Modal.Actions>
        </Modal>
    );
}
